/* ============================================================================
   LED.nl — productpagina, gedrag
   ----------------------------------------------------------------------------
   Eén bestand voor de hele PDP. Alles is defensief: elk onderdeel bestaat
   alleen als de bijbehorende markup er is, zodat een uitgeschakelde sectie
   nooit de rest meesleurt.

   Zichtbare tekst komt zonder uitzondering uit data-attributen die door
   Liquid uit de sectie-instellingen worden gevuld — tekst die in JavaScript
   staat is namelijk niet vertaalbaar door Translate & Adapt.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* --------------------------------------------------------------------------
     Geld opmaken. Shopify's money-filter draait server-side; hier hebben we
     hetzelfde nodig voor prijzen die we in de browser uitrekenen. We leiden
     het formaat af van een bedrag dat Liquid al heeft gerenderd, zodat een
     andere market (Duitsland) vanzelf goed gaat.
     ------------------------------------------------------------------------ */
  var moneyFormat = (function () {
    var sample = $('[data-pdp-price-incl]');
    var text = sample ? sample.textContent.trim() : '€ 0,00';
    var comma = text.indexOf(',') > text.indexOf('.');
    return {
      prefix: text.replace(/[\d.,\s]+$/, '').trim(),
      comma: comma
    };
  })();

  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2);
    var parts = v.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyFormat.comma ? '.' : ',');
    var out = whole + (moneyFormat.comma ? ',' : '.') + parts[1];
    return (moneyFormat.prefix ? moneyFormat.prefix + ' ' : '') + out;
  }

  /* --------------------------------------------------------------------------
     1. GALERIJ
     De track is een scroll-snap carrousel, dus swipen werkt zonder JavaScript.
     Hier houden we alleen de teller, de actieve miniatuur en de pijlen bij.
     ------------------------------------------------------------------------ */
  (function gallery() {
    var root = $('[data-pdp-gallery]');
    if (!root) return;

    var track = $('[data-pdp-track]', root);
    if (!track) return;

    var slides = $$('[data-pdp-slide]', track);
    var thumbs = $$('[data-pdp-thumb]', root);
    var counter = $('[data-pdp-count]', root);
    var prev = $('[data-pdp-prev]', root);
    var next = $('[data-pdp-next]', root);
    if (slides.length < 2) return;

    var current = 0;

    function goTo(i) {
      var idx = Math.max(0, Math.min(slides.length - 1, i));
      // Bewust géén smooth: op deze track blijft een vloeiende scroll steken
      // op positie 0 — zowel via scroll-behavior in CSS als via
      // scrollTo({behavior:'smooth'}). Het theme kaapt het scrollgedrag.
      // Een directe sprong is voor een fotogalerij prima en werkt altijd.
      track.scrollLeft = slides[idx].offsetLeft - track.offsetLeft;
      sync();
    }

    // De miniaturenstrook laten meelopen met de foto die in beeld staat.
    // Zonder dit blijft de actieve miniatuur bij foto 4 en verder buiten
    // beeld en lijkt de strook stil te staan.
    function keepThumbVisible(i) {
      var thumb = thumbs[i];
      if (!thumb) return;
      var strip = thumb.parentElement;
      if (!strip || strip.scrollWidth <= strip.clientWidth) return;

      var left = thumb.offsetLeft - strip.offsetLeft;
      var right = left + thumb.offsetWidth;
      var marge = 12;
      var doel = null;

      if (left < strip.scrollLeft + marge) {
        doel = left - marge;
      } else if (right > strip.scrollLeft + strip.clientWidth - marge) {
        doel = right - strip.clientWidth + marge;
      }
      if (doel === null) return;

      doel = Math.max(0, Math.min(doel, strip.scrollWidth - strip.clientWidth));
      strip.scrollLeft = doel;
    }

    function sync() {
      // Welke slide staat het dichtst bij het midden van de track?
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (best === current) return;
      current = best;

      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === best ? 'true' : 'false'); });
      keepThumbVisible(best);
      if (counter) counter.textContent = (best + 1) + '/' + slides.length;
      if (prev) prev.hidden = best === 0;
      if (next) next.hidden = best === slides.length - 1;
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.pdpThumb, 10)); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    // Pijltjestoetsen wanneer de focus in de galerij staat.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(current - 1); }
      else if (e.key === 'ArrowRight') { goTo(current + 1); }
    });

    if (prev) prev.hidden = true;
    sync();
  })();

  /* --------------------------------------------------------------------------
     2. HOEVEELHEID
     ------------------------------------------------------------------------ */
  function getQtyInput() { return $('[data-pdp-qty-input]'); }

  (function quantity() {
    var input = getQtyInput();
    if (!input) return;

    // De teller in de sticky koopbalk toont hetzelfde getal maar is géén
    // tweede invoerveld: één veld blijft de bron, de rest spiegelt mee.
    function spiegel() {
      var v = parseInt(input.value, 10) || 1;
      $$('[data-pdp-qty-mirror]').forEach(function (el) { el.textContent = v; });
    }

    // De knoppen worden document-breed gebonden, dus die in de sticky balk
    // doen automatisch mee zonder eigen afhandeling.
    $$('[data-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.pdpQty, 10) || 1;
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (!v || v < 1) input.value = 1;
      spiegel();
    });

    // Ook meelopen als iets anders het veld zet, bijvoorbeeld een klik op
    // een staffelchip.
    input.addEventListener('input', spiegel);
    spiegel();
  })();

  /* --------------------------------------------------------------------------
     3. LEVERBELOFTE MET AFTELKLOK
     Rekent altijd in Europe/Amsterdam, ongeacht de klok van de bezoeker.
     Weekenden en ingestelde feestdagen tellen niet als werkdag. Er wordt
     nooit een tijdstip binnen de dag beloofd — PostNL garandeert geen
     ochtendlevering.
     ------------------------------------------------------------------------ */
  (function delivery() {
    var root = $('[data-pdp-delivery]');
    if (!root) return;
    var out = $('[data-pdp-delivery-text]', root);
    if (!out) return;

    var t = {
      locale: root.dataset.locale || 'nl',
      tomorrow: root.dataset.lblTomorrow || 'morgen',
      dayAfter: root.dataset.lblDayafter || 'overmorgen',
      pattern: root.dataset.lblPattern || '[[dag]] in huis',
      countdown: root.dataset.lblCountdown || 'Bestel binnen [[tijd]]',
      nextday: root.dataset.lblNextday || 'bestel voor [[tijd]] op de eerstvolgende werkdag'
    };

    var cutoffStr = root.dataset.cutoff || '13:30';
    var cutoff = cutoffStr.split(':');
    var cutoffH = parseInt(cutoff[0], 10);
    var cutoffM = parseInt(cutoff[1] || '0', 10);

    var closed = (root.dataset.closedDates || '').split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);

    function nowInNL() {
      var p = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Amsterdam',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date()).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
      return {
        date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)),
        h: +p.hour % 24, m: +p.minute, s: +p.second
      };
    }

    function iso(d) { return d.toISOString().slice(0, 10); }
    function isWorkday(d) {
      var day = d.getUTCDay();
      if (day === 0 || day === 6) return false;
      return closed.indexOf(iso(d)) === -1;
    }
    function addDays(d, n) {
      var c = new Date(d.getTime());
      c.setUTCDate(c.getUTCDate() + n);
      return c;
    }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function render() {
      var n = nowInNL();
      var today = n.date;
      var nowSec = n.h * 3600 + n.m * 60 + n.s;
      var cutSec = cutoffH * 3600 + cutoffM * 60;
      var beforeCutoff = nowSec < cutSec;

      var dispatch = new Date(today.getTime());
      if (!(isWorkday(dispatch) && beforeCutoff)) {
        do { dispatch = addDays(dispatch, 1); } while (!isWorkday(dispatch));
      }

      // Bezorging: de eerstvolgende dag die geen zondag of gesloten dag is.
      var delivery = addDays(dispatch, 1);
      while (delivery.getUTCDay() === 0 || closed.indexOf(iso(delivery)) !== -1) {
        delivery = addDays(delivery, 1);
      }

      var diff = Math.round((delivery - today) / 86400000);
      var label;
      if (diff === 1) label = t.tomorrow;
      else if (diff === 2) label = t.dayAfter;
      else label = new Intl.DateTimeFormat(t.locale, { weekday: 'long', timeZone: 'UTC' }).format(delivery);

      var dag = label.charAt(0).toUpperCase() + label.slice(1);
      var html = '<span class="pdp-delivery__day">' + t.pattern.replace('[[dag]]', dag) + '</span>';

      if (iso(dispatch) === iso(today)) {
        var rest = cutSec - nowSec;
        var hrs = Math.floor(rest / 3600);
        var min = Math.floor((rest % 3600) / 60);
        var sec = rest % 60;
        var clock = hrs > 0 ? (hrs + ':' + pad(min) + ':' + pad(sec)) : (pad(min) + ':' + pad(sec));
        html += ' <span class="pdp-delivery__rest">' +
                t.countdown.replace('[[tijd]]', '<span class="pdp-delivery__clock">' + clock + '</span>') +
                '</span>';
        // Het laatste uur krijgt een andere kleur; daaronder wordt het dringend.
        root.classList.toggle('pdp-delivery--urgent', rest < 3600);
      } else {
        // Na de cut-off. Niet zeggen "bestel voor 13:30 op de eerstvolgende
        // werkdag" — dat leest alsof je nú niets meer kunt bestellen. Wat er
        // feitelijk gebeurt is dat de bestelling de eerstvolgende werkdag de
        // deur uit gaat, en die dag noemen we.
        var dispatchDiff = Math.round((dispatch - today) / 86400000);
        var dispatchLabel = dispatchDiff === 1
          ? t.tomorrow
          : new Intl.DateTimeFormat(t.locale, { weekday: 'long', timeZone: 'UTC' }).format(dispatch);
        html += ' <span class="pdp-delivery__rest">' + t.nextday.replace('[[dag]]', dispatchLabel) + '</span>';
        root.classList.remove('pdp-delivery--urgent');
      }
      out.innerHTML = html;
    }

    render();
    // Elke seconde: de klok telt echt af. Staat het tabblad op de achtergrond,
    // dan slaan we het over — dat scheelt batterij en de klok wordt bij
    // terugkeer meteen bijgewerkt.
    setInterval(function () { if (!document.hidden) render(); }, 1000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); });
  })();

  /* --------------------------------------------------------------------------
     4. STAFFELKORTING
     De regels komen uit de app-embed van Orichi Volume Discount. Wij tekenen
     ze zelf, zodat ze bij de huisstijl passen. Klikken zet alleen de
     hoeveelheid: de korting wordt door de app automatisch op regelniveau in
     de winkelwagen verrekend (geverifieerd 4 aug 2026).

     Vinden we geen regels, dan doen we niets en blijft Orichi's eigen widget
     staan als vangnet.
     ------------------------------------------------------------------------ */
  // Sets óf staffel, nooit allebei (regel eigenaar, 10 sep 2026). De
  // set-kiezer (snippet pdp-pack-picker, alleen de variant met echte sets)
  // staat standaard uit en verschijnt pas als vaststaat dat er géén staffel
  // op de pagina komt. De staffel heeft voorrang.
  function toonSets() {
    $$('[data-pdp-packs-sets]').forEach(function (el) { el.classList.add('is-zonder-staffel'); });
  }

  (function tiers() {
    var host = $('[data-pdp-tiers]');
    if (!host) { toonSets(); return; }

    var productId = String(host.dataset.productId || '');
    var collections = (host.dataset.collections || '').split(',').filter(Boolean);
    var tags = (host.dataset.tags || '').split('||').filter(Boolean);
    var basePrice = parseInt(host.dataset.price, 10) || 0;

    var L = {
      title: host.dataset.lblTitle || 'Meer stuks, lagere prijs',
      hint: host.dataset.lblHint || '',
      single: host.dataset.lblSingle || 'Los stuk',
      each: host.dataset.lblEach || 'per stuk',
      save: host.dataset.lblSave || '[[procent]]% korting',
      pieces: host.dataset.lblPieces || '[[n]] stuks',
      foot: host.dataset.foot || ''
    };

    function idOf(gid) { return String(gid || '').split('/').pop(); }

    // Campagnes die Orichi wél in de paginagegevens meestuurt (met active: true),
    // maar die de kortingsfunctie in de winkelwagen niet meer toepast. Gemeten op
    // 10 aug 2026: campagne 2626 "Test" belooft 10% bij 4 stuks op vier TL-buizen,
    // terwijl de wagen daar "TL  - 4 stuks" á 2,5% geeft. Zonder deze lijst belooft
    // de productpagina een korting die de kassa niet nakomt.
    //   Dit is een pleister: de echte oplossing is de campagne in de Orichi-app
    //   verwijderen. Staat die er niet meer, dan mag deze lijst leeg.
    var DODE_CAMPAGNES = [2626];

    function findCampaigns() {
      var vol = window.orichiVolume;
      if (!vol || !Array.isArray(vol.orichiVolumeDiscounts)) return null;

      var matches = vol.orichiVolumeDiscounts.filter(function (c) {
        if (!c.active) return false;
        if (DODE_CAMPAGNES.indexOf(Number(c.id)) !== -1) return false;

        // Uitsluitingen gaan vóór insluitingen.
        if (c.exSpecificProducts && (c.products || []).some(function (p) {
          return p.isExclude && idOf(p.productId) === productId;
        })) return false;
        if (c.exAllProductsInCollections && (c.collections || []).some(function (x) {
          return x.isExclude && collections.indexOf(idOf(x.collectionId)) !== -1;
        })) return false;

        if (c.allProducts) return true;
        if (c.specificProducts && (c.products || []).some(function (p) {
          return !p.isExclude && idOf(p.productId) === productId;
        })) return true;
        if (c.allProductsInCollection && (c.collections || []).some(function (x) {
          return !x.isExclude && collections.indexOf(idOf(x.collectionId)) !== -1;
        })) return true;
        if (c.specificProductTags && (c.tags || []).some(function (tg) {
          return tags.indexOf(tg) !== -1;
        })) return true;
        return false;
      });

      if (!matches.length) return null;

      // Meerdere campagnes kunnen op één product slaan (een collectieregel én
      // een productregel). De app past er één toe; wij tonen de campagne met
      // de hoogste maximale korting, want dat is wat de klant kan halen.
      var best = null, bestMax = -1;
      matches.forEach(function (c) {
        (c.volumeDiscounts || []).forEach(function (vd) {
          if (!vd.active) return;
          var max = (vd.rules || []).reduce(function (m, r) {
            return r.discountType === 'percentage_discount' ? Math.max(m, r.amount) : m;
          }, 0);
          if (max > bestMax) { bestMax = max; best = vd; }
        });
      });
      return best;
    }

    function build(vd) {
      var rules = (vd.rules || []).slice()
        .filter(function (r) { return r.quantity > 0; })
        .sort(function (a, b) { return a.quantity - b.quantity; });
      if (!rules.length) return false;
      // Alleen een echte staffel telt: minstens één regel met korting. Een
      // campagne met alleen een 1-stuks-regel tekent geen tabel, en dan
      // mogen de sets gewoon blijven staan.
      if (!rules.some(function (r) { return r.discountType === 'percentage_discount' && r.amount > 0; })) return false;

      // Begint de staffel niet bij 1, dan zetten we zelf een regel voor het
      // losse stuk erboven. Zonder die regel lijkt het alsof je er minstens
      // vier moet afnemen — dat is bij drie van de zes campagnes het geval.
      if (rules[0].quantity > 1) {
        rules.unshift({ quantity: 1, discountType: 'none', amount: 0, _synthetic: true });
      }

      var wrap = document.createElement('div');
      wrap.className = 'pdp-tiers';

      var head = document.createElement('div');
      head.className = 'pdp-tiers__head';
      var h = document.createElement('p');
      h.className = 'pdp-tiers__title';
      h.textContent = L.title;
      head.appendChild(h);
      if (L.hint) {
        var hint = document.createElement('span');
        hint.className = 'pdp-tiers__hint';
        hint.textContent = L.hint;
        head.appendChild(hint);
      }
      wrap.appendChild(head);

      var list = document.createElement('div');
      list.className = 'pdp-tiers__list';
      // Op mobiel worden de regels tegels naast elkaar (10 sep 2026). Dat past
      // tot vier stuks; bij meer blijft ook op mobiel de lijst staan.
      if (rules.length <= 4) list.classList.add('pdp-tiers__list--tegels');

      rules.forEach(function (r) {
        var pct = r.discountType === 'percentage_discount' ? r.amount : 0;
        // Orichi trekt de korting per stuk af en kapt daarbij de centen af, niet
        // afrondend: bij € 7,49 en 2,5% rekent de wagen € 0,18 korting (7,49 x
        // 0,025 = 0,187), dus € 7,31 per stuk. Met Math.round kwamen wij op
        // € 7,30 en stond er een cent te weinig op de productpagina.
        var each = basePrice - Math.floor(basePrice * pct / 100);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-tier';
        btn.dataset.qty = r.quantity;
        btn.setAttribute('aria-current', 'false');

        var qty = document.createElement('span');
        qty.className = 'pdp-tier__qty';
        qty.textContent = r.quantity === 1 ? L.single : L.pieces.replace('[[n]]', r.quantity);
        // De eigen titel van de app als ondertitel, maar alleen als hij iets
        // toevoegt: veel regels heten letterlijk "4 stuks".
        var sub = (r.subtitle || '').trim();
        if (sub && sub.toLowerCase() !== qty.textContent.toLowerCase()) {
          var small = document.createElement('small');
          small.textContent = sub;
          qty.appendChild(small);
        }
        btn.appendChild(qty);

        var price = document.createElement('span');
        price.className = 'pdp-tier__each';
        price.textContent = money(each);
        var perLabel = document.createElement('small');
        perLabel.textContent = L.each;
        price.appendChild(perLabel);
        btn.appendChild(price);

        var save = document.createElement('span');
        save.className = pct > 0 ? 'pdp-tier__save' : 'pdp-tier__save pdp-tier__save--none';
        save.textContent = pct > 0 ? L.save.replace('[[procent]]', String(pct).replace('.', ',')) : '—';
        btn.appendChild(save);

        // Kort label voor de tegels op mobiel: alleen "−7,5%". Het volledige
        // label ("7,5% korting") past niet in een tegel van ±75px; de CSS toont
        // op mobiel het een en op desktop het ander, nooit beide.
        if (pct > 0) {
          var kort = document.createElement('span');
          kort.className = 'pdp-tier__kort';
          kort.textContent = '−' + String(pct).replace('.', ',') + '%';
          btn.appendChild(kort);
        }

        btn.addEventListener('click', function () {
          var input = getQtyInput();
          if (!input) return;
          input.value = r.quantity;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          mark(r.quantity);
        });

        list.appendChild(btn);
      });

      wrap.appendChild(list);

      if (L.foot) {
        var foot = document.createElement('div');
        foot.className = 'pdp-tiers__foot';
        foot.innerHTML = L.foot;
        wrap.appendChild(foot);
      }

      host.appendChild(wrap);
      // Pas nu Orichi's eigen widget verbergen: staat onze tabel er niet,
      // dan moet die van hen blijven staan.
      document.body.classList.add('pdp-has-own-tiers');

      var input = getQtyInput();
      if (input) {
        input.addEventListener('change', function () { mark(parseInt(input.value, 10) || 1); });
        mark(parseInt(input.value, 10) || 1);
      }
      return true;
    }

    // Welke staffel geldt bij dit aantal? De hoogste drempel die je haalt.
    function mark(qty) {
      var best = null;
      $$('.pdp-tier').forEach(function (b) {
        var q = parseInt(b.dataset.qty, 10);
        b.setAttribute('aria-current', 'false');
        if (q <= qty && (!best || q > parseInt(best.dataset.qty, 10))) best = b;
      });
      if (best) best.setAttribute('aria-current', 'true');
    }

    // De app-embed laadt asynchroon; we proberen het een aantal keer voordat
    // we het opgeven en de widget van de app zijn werk laten doen.
    var tries = 0;
    (function attempt() {
      var vd = findCampaigns();
      if (vd && build(vd)) return;
      // De Orichi-gegevens zijn geladen maar er is geen bruikbare staffel voor
      // dit product: dan mogen de sets meteen verschijnen, niet pas na 5 s.
      var geladen = window.orichiVolume && Array.isArray(window.orichiVolume.orichiVolumeDiscounts);
      if (vd || geladen) { toonSets(); return; }
      // Komen de gegevens helemaal niet, dan is er ook geen Orichi-widget:
      // na het opgeven verschijnen de sets alsnog.
      if (++tries > 25) { toonSets(); return; }
      setTimeout(attempt, 200);
    })();
  })();

  /* --------------------------------------------------------------------------
     5. HULPKNOPPEN
     ------------------------------------------------------------------------ */
  (function help() {
    var toggles = $$('[data-pdp-help-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.pdpHelpToggle;
        var panel = $('[data-pdp-help-panel="' + key + '"]');
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';

        // Eén paneel tegelijk: twee open panelen duwen de pagina te ver uit.
        toggles.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var p = $('[data-pdp-help-panel="' + b.dataset.pdpHelpToggle + '"]');
          if (p) p.hidden = true;
        });

        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });

    // Zijn we nu telefonisch bereikbaar? Bepaald in Amsterdamse tijd, zodat
    // een bezoeker uit een andere tijdzone geen onjuiste belofte ziet.
    var svc = $('[data-pdp-help-panel="service"]');
    if (svc) {
      var badge = $('[data-pdp-open]', svc);
      var text = $('[data-pdp-open-text]', svc);
      if (badge && text) {
        var from = (svc.dataset.openFrom || '08:00').split(':');
        var to = (svc.dataset.openTo || '13:00').split(':');
        var p = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Amsterdam', weekday: 'short',
          hour: '2-digit', minute: '2-digit', hour12: false
        }).formatToParts(new Date()).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
        var mins = (+p.hour % 24) * 60 + (+p.minute);
        var weekend = p.weekday === 'Sat' || p.weekday === 'Sun';
        var open = !weekend &&
                   mins >= (+from[0] * 60 + (+from[1] || 0)) &&
                   mins < (+to[0] * 60 + (+to[1] || 0));

        text.textContent = open ? (svc.dataset.lblOpen || '') : (svc.dataset.lblClosed || '');
        badge.classList.toggle('pdp-open--closed', !open);
        badge.hidden = false;
      }
    }

    // Voorgevulde adviesmail. Liquid kan de regeleindes in een mailto-body
    // niet betrouwbaar coderen, dus dat doen we hier. Er zijn er twee: de
    // knop in het koopblok en die in het adviesblok onderaan.
    $$('[data-pdp-advice-mail]').forEach(function (mail) {
      mail.href = 'mailto:' + mail.dataset.email +
                  '?subject=' + encodeURIComponent(mail.dataset.subject || '') +
                  '&body=' + encodeURIComponent(mail.dataset.body || '');
    });
  })();

  /* --------------------------------------------------------------------------
     6. UITKLAPPERS (betalen, retour, specificatiegroepen)
     ------------------------------------------------------------------------ */
  (function accordions() {
    $$('[data-pdp-acc-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Op desktop staan de specificatiegroepen altijd open; de kop is daar
        // geen knop meer (zie de CSS) en mag dus ook niets dichtklappen.
        if (btn.closest('.pdp-specgroup') && window.matchMedia('(min-width: 900px)').matches) return;
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });

    // Beginstand van de specificatiegroepen. Op mobiel staat alleen de eerste
    // groep open, anders is de pagina meteen tweeduizend pixels lang; op
    // desktop staat alles open. Dit gebeurt in JavaScript omdat het hidden-
    // attribuut geen media queries kent.
    var groups = $$('[data-pdp-specgroup]');
    if (!groups.length) return;

    function applyDefault() {
      var wide = window.matchMedia('(min-width: 900px)').matches;
      groups.forEach(function (g, i) {
        var head = $('.pdp-specgroup__head', g);
        var body = $('.pdp-specgroup__body', g);
        if (!head || !body) return;
        var open = wide || i === 0;
        body.hidden = !open;
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    applyDefault();
    // Bij het draaien van een telefoon of het verslepen van een venster over
    // de grens heen moet de stand meebewegen, anders staat de tabel op
    // desktop half dicht zonder zichtbare knop om hem te openen.
    var mq = window.matchMedia('(min-width: 900px)');
    if (mq.addEventListener) mq.addEventListener('change', applyDefault);
    else if (mq.addListener) mq.addListener(applyDefault);
  })();

  /* --------------------------------------------------------------------------
     7. STICKY KOOPBALK
     Verschijnt zodra de echte koopknop uit beeld is. De knop in de balk klikt
     de echte knop aan, zodat er één plek is waar het toevoegen gebeurt en de
     AJAX-afhandeling van het theme intact blijft.
     ------------------------------------------------------------------------ */
  (function sticky() {
    var bar = $('[data-pdp-sticky]');
    var atc = $('[data-pdp-atc]');
    if (!bar || !atc) return;

    var stickyBtn = $('[data-pdp-sticky-atc]', bar);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { atc.click(); });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(atc);
  })();

  /* --------------------------------------------------------------------------
     8. "LEES MEER" BIJ DE OMSCHRIJVING
     ------------------------------------------------------------------------ */
  (function readMore() {
    $$('[data-pdp-more]').forEach(function (btn) {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;

      // Past de tekst toch al binnen de hoogte, dan is de knop overbodig.
      if (target.scrollHeight <= target.clientHeight + 8) {
        target.classList.remove('pdp-rte--clamped');
        btn.hidden = true;
        return;
      }

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        target.classList.toggle('pdp-rte--clamped', open);
        $('[data-pdp-more-label]', btn).textContent = open ? btn.dataset.labelMore : btn.dataset.labelLess;
        if (open) target.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  })();

  /* --------------------------------------------------------------------------
     9. SPECIFICATIES ZOEKEN
     Bij ruim veertig velden is scrollen langs alle groepen onwerkbaar. Het
     zoekveld filtert op label én waarde, en verbergt groepen die leeg raken.
     ------------------------------------------------------------------------ */
  (function specSearch() {
    var input = $('[data-pdp-spec-search]');
    if (!input) return;

    var rows = $$('[data-pdp-specrow]');
    var groups = $$('[data-pdp-specgroup]');
    var empty = $('[data-pdp-spec-empty]');

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      rows.forEach(function (r) {
        r.hidden = q !== '' && (r.dataset.search || '').indexOf(q) === -1;
      });

      var anyVisible = false;
      groups.forEach(function (g) {
        var visible = $$('[data-pdp-specrow]', g).some(function (r) { return !r.hidden; });
        g.hidden = !visible;
        if (visible) anyVisible = true;
        // Tijdens het zoeken staan gevonden groepen open, ook op mobiel.
        if (q !== '' && visible) {
          var body = $('.pdp-specgroup__body', g);
          var head = $('.pdp-specgroup__head', g);
          if (body) body.hidden = false;
          if (head) head.setAttribute('aria-expanded', 'true');
        }
      });
      if (empty) empty.hidden = anyVisible || q === '';
    });
  })();

  /* --------------------------------------------------------------------------
     9b. UITLEG BIJ EEN VAKTERM
     De i-knopjes hadden alleen een title-attribuut. Dat verschijnt pas na een
     seconde hoveren en op een telefoon nooit, dus in de praktijk deden ze
     niets. Hier krijgen ze een echte popover die opent op klik of tik.
     ------------------------------------------------------------------------ */
  (function explain() {
    var buttons = $$('[data-pdp-explain]');
    if (!buttons.length) return;

    var pop = document.createElement('div');
    pop.className = 'pdp-pop';
    pop.setAttribute('role', 'tooltip');
    pop.hidden = true;
    document.body.appendChild(pop);

    var open = null;

    function close() {
      if (!open) return;
      open.setAttribute('aria-expanded', 'false');
      open = null;
      pop.hidden = true;
    }

    function show(btn) {
      pop.textContent = btn.dataset.pdpExplain || '';
      pop.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      open = btn;

      // Plaatsen onder het knopje, maar binnen het venster houden.
      var r = btn.getBoundingClientRect();
      var w = pop.offsetWidth;
      var left = r.left + r.width / 2 - w / 2;
      left = Math.max(12, Math.min(left, document.documentElement.clientWidth - w - 12));

      var top = r.bottom + window.scrollY + 8;
      // Past hij niet onder het knopje, dan erboven.
      if (r.bottom + pop.offsetHeight + 16 > window.innerHeight) {
        top = r.top + window.scrollY - pop.offsetHeight - 8;
      }
      pop.style.left = (left + window.scrollX) + 'px';
      pop.style.top = top + 'px';
    }

    buttons.forEach(function (btn) {
      // Het title-attribuut moet weg zodra JavaScript het overneemt, anders
      // verschijnt de browsertooltip alsnog over de popover heen.
      btn.removeAttribute('title');

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (open === btn) { close(); return; }
        close();
        show(btn);
      });
    });

    document.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', close);
    window.addEventListener('scroll', close, { passive: true });
  })();

  /* --------------------------------------------------------------------------
     10. ANKERBALK
     Markeert het blok waar je naar kijkt en scrollt er zacht naartoe. De
     ankers zijn echte id's, dus een link als /products/x#specs werkt ook
     zonder JavaScript.
     ------------------------------------------------------------------------ */
  /* Een sectie die zichzelf later weghaalt laat anders een dood anker achter:
     de opruiming hieronder draait bij het laden, terwijl bijvoorbeeld het
     alternatievenblok pas verdwijnt als het aanbevelingenverzoek niets
     oplevert. Vandaar deze functie, die op dat moment alsnog het bijbehorende
     anker verwijdert — en de balk zelf als er niets overblijft. */
  window.pdpVerwijderAnker = function (id) {
    var bar = $('[data-pdp-anchorbar]');
    if (!bar) return;
    var link = $('a[href="#' + id + '"]', bar);
    if (link) link.remove();
    if (!$('a[href^="#"]', bar)) bar.remove();
  };

  (function anchors() {
    var bar = $('[data-pdp-anchorbar]');

    // De sterrenlink in het koopblok wijst naar het reviewsblok en heeft
    // dezelfde id-vertaling nodig als de balk hieronder. Die staat los van de
    // balk, dus hij wordt hier apart afgehandeld.
    var star = $('.pdp-metarow a[href^="#"]');
    if (star) {
      var starTarget = document.getElementById(star.getAttribute('href').slice(1)) ||
                       document.querySelector('[id$="__' + star.getAttribute('href').slice(1) + '"]');
      if (!starTarget) {
        // Geen reviewsblok op deze pagina: dan is de link een dood eind.
        star.removeAttribute('href');
      } else {
        star.addEventListener('click', function (e) {
          e.preventDefault();
          starTarget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      }
    }

    if (!bar) return;

    // Een sectie krijgt van Shopify het id shopify-section-<template>__<key>,
    // dus een anker naar een sectie die we niet zelf schrijven (het Judge.me-
    // blok) kan de volledige id niet kennen. Daarom accepteren we ook een
    // achtervoegsel.
    function resolve(id) {
      return document.getElementById(id) ||
             document.querySelector('[id$="__' + id + '"]');
    }

    // Ankers zonder doel weghalen; blijft er niets over, dan de balk zelf ook.
    // Dit kan pas hier: de balk staat bóven de blokken waarnaar hij verwijst.
    $$('a[href^="#"]', bar).forEach(function (a) {
      if (!resolve(a.getAttribute('href').slice(1))) a.remove();
    });
    if (!$('a[href^="#"]', bar)) { bar.remove(); return; }

    var links = $$('a[href^="#"]', bar);
    var targets = links.map(function (a) { return resolve(a.getAttribute('href').slice(1)); });

    links.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        var target = targets[i];
        if (!target) return;
        e.preventDefault();
        // De sticky header van het theme plus onze eigen balk moeten er nog
        // boven passen, anders landt de kop erachter.
        var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - (bar.offsetHeight + headerH + 12);
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        history.replaceState(null, '', a.getAttribute('href'));
      });
    });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = targets.indexOf(e.target);
        if (i === -1) return;
        links.forEach(function (a, j) { a.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    targets.forEach(function (t) { if (t) io.observe(t); });
  })();

  /* --------------------------------------------------------------------------
     11. ALTERNATIEVEN — tabbladen
     ------------------------------------------------------------------------ */
  (function recommendations() {
    var grid = $('[data-pdp-recommend]');
    if (!grid || grid.querySelector('.pdp-alt')) return;

    var url = '/recommendations/products?section_id=' + encodeURIComponent(grid.dataset.sectionId) +
              '&product_id=' + encodeURIComponent(grid.dataset.productId) +
              '&limit=' + encodeURIComponent(grid.dataset.limit || 5) +
              '&intent=related';

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-pdp-altgrid="similar"] .pdp-alt');
        if (!cards.length) throw new Error('geen kaarten');
        Array.prototype.forEach.call(cards, function (c) { grid.appendChild(c); });
      })
      .catch(function () {
        // Geen aanbevelingen: het tabblad "Vergelijkbaar" wijst dan naar een
        // leeg vlak. Dan liever het tabblad weghalen en op het eerstvolgende
        // tabblad met inhoud beginnen.
        var tab = $('[data-pdp-alttab="similar"]');
        if (tab) tab.remove();
        grid.remove();
        var first = $('[data-pdp-alttab]');
        if (first) {
          first.setAttribute('aria-selected', 'true');
          var target = $('[data-pdp-altgrid="' + first.dataset.pdpAlttab + '"]');
          if (target) target.hidden = false;
        } else {
          // Helemaal niets te tonen: de hele sectie kan weg. Het anker in de
          // balk moet dan mee, anders blijft "Andere opties" staan als knop
          // die nergens heen springt.
          var section = $('#alternatieven');
          if (section) section.remove();
          if (window.pdpVerwijderAnker) window.pdpVerwijderAnker('alternatieven');
        }
      });
  })();

  /* --------------------------------------------------------------------------
     10b. KNOP NAAR DE LICHTPLANNER
     De planner staat alleen op armaturen. Of die sectie er is weet Liquid in
     het koopblok niet, dus de knop staat verborgen in de markup en verschijnt
     hier pas als het doel echt bestaat.
     ------------------------------------------------------------------------ */
  (function planLink() {
    var link = $('[data-pdp-planlink]');
    if (!link) return;
    var doel = document.getElementById('lichtplan');
    if (!doel) return;

    link.hidden = false;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      doel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#lichtplan');
      // De eerste maatinvoer krijgt de focus, zodat je meteen kunt typen.
      var eerste = doel.querySelector('[data-plan-l]');
      if (eerste) setTimeout(function () { eerste.focus({ preventScroll: true }); }, 500);
    });
  })();

  /* --------------------------------------------------------------------------
     11b. LAATST BEKEKEN
     Het theme houdt bezochte producten bij in localStorage. We vragen deze
     sectie opnieuw op via de zoek-URL met een id:-query — hetzelfde patroon
     dat het theme zelf gebruikt — en zetten de kaarten in de grid.
     ------------------------------------------------------------------------ */
  (function recentlyViewed() {
    var root = $('[data-pdp-recent]');
    if (!root) return;

    var grid = $('[data-pdp-recent-grid]', root);
    if (!grid) return;

    var current = String(root.dataset.current || '');

    var ids;
    try {
      ids = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
    } catch (e) {
      ids = [];
    }
    if (!Array.isArray(ids)) ids = [];

    // Dit bezoek zelf vastleggen. Het theme deed dat vanuit de oude
    // productsectie, en die staat er niet meer — zonder deze regels blijft de
    // geschiedenis staan op wat er vóór de nieuwe pagina in stond.
    if (current) {
      var bijgewerkt = [current].concat(ids.map(String).filter(function (id) {
        return id !== current;
      })).slice(0, 20);
      try {
        localStorage.setItem('recentlyViewedProducts', JSON.stringify(bijgewerkt.map(Number)));
      } catch (e) { /* privémodus of vol: niet erg */ }
    }

    var limit = parseInt(root.dataset.limit, 10) || 5;
    ids = ids.map(String).filter(function (id, i, arr) {
      return id !== current && arr.indexOf(id) === i;
    }).slice(0, limit);

    if (!ids.length) return;

    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var url = '/search?type=product&q=' + encodeURIComponent(q) +
              '&section_id=' + encodeURIComponent(root.dataset.sectionId);

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-pdp-recent-grid] .pdp-alt');
        if (!cards.length) return;
        Array.prototype.forEach.call(cards, function (c) { grid.appendChild(c); });
        root.hidden = false;

        var clear = $('[data-pdp-recent-clear]', root);
        if (clear) {
          clear.hidden = false;
          clear.addEventListener('click', function () {
            try { localStorage.removeItem('recentlyViewedProducts'); } catch (e) {}
            root.hidden = true;
          });
        }
      })
      .catch(function () { /* geen geschiedenis te tonen: sectie blijft verborgen */ });
  })();

  (function altTabs() {
    var tabs = $$('[data-pdp-alttab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.pdpAlttab;
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        $$('[data-pdp-altgrid]').forEach(function (g) {
          g.hidden = g.dataset.pdpAltgrid !== key;
        });
      });
    });
  })();

  /* --------------------------------------------------------------------------
     12. BESPARINGSREKENAAR
     Rekent uitsluitend met wat de klant zelf invult en met het vermogen van
     dit product. We beloven dus niets over de opbrengst — het is een som die
     de bezoeker zelf kan narekenen.
     ------------------------------------------------------------------------ */
  (function calculator() {
    var root = $('[data-pdp-calc]');
    if (!root) return;

    var watt = parseFloat(root.dataset.watt || '0');
    if (!watt) { root.hidden = true; return; }

    var oldW = $('[data-calc-old]', root);
    var count = $('[data-calc-count]', root);
    var hours = $('[data-calc-hours]', root);
    var rate = $('[data-calc-rate]', root);
    var outYear = $('[data-calc-year]', root);
    var outKwh = $('[data-calc-kwh]', root);

    function calc() {
      var o = parseFloat(oldW.value) || 0;
      var n = parseFloat(count.value) || 0;
      var h = parseFloat(hours.value) || 0;
      var r = parseFloat(String(rate.value).replace(',', '.')) || 0;

      var saveW = Math.max(0, o - watt);
      var kwh = saveW * n * h * 365 / 1000;
      var euro = kwh * r;

      if (outKwh) outKwh.textContent = kwh.toFixed(0);
      if (outYear) outYear.textContent = money(Math.round(euro * 100));
    }

    [oldW, count, hours, rate].forEach(function (el) {
      if (el) el.addEventListener('input', calc);
    });
    calc();
  })();

})();
